import { jsonMember, jsonObject } from 'typedjson';
import { dateSerializer } from '@api/common/json/date-serializer';

@jsonObject
export class SequenceFilterCollectionRequest {
  @jsonMember name?: string;
  @jsonMember({ serializer: dateSerializer() }) createdAtFrom?: Date;
  @jsonMember({ serializer: dateSerializer() }) createdAtTo?: Date;
  @jsonMember({ serializer: dateSerializer() }) generatedAtFrom?: Date;
  @jsonMember({ serializer: dateSerializer() }) generatedAtTo?: Date;
  @jsonMember comment?: string;
}
